export default {
    confirm: (state) => state.confirm,
    message: (state) => state.message
};
